import { Link, useNavigate, useParams } from "react-router-dom";
import "./style.css"
import { Helmet } from "react-helmet-async";
import { useEffect, useRef, useState } from "react";
import Screen from "../../Layouts/Screen/Screen";
import { CheckCircle, Clock, Edit, Heart, MessageCircle, Send, Smile, Trash, XSquare } from "react-feather";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import { LIMIT_REQUEST_COMMENTS, LIMIT_TEXT_COMMENT } from "../../../utils/vars";
import { useAuth } from "../../../global-components/src";
import axios from "axios";
import { useAiMentionLimitBanner } from "../../../hooks/useAiMentionLimit";
import AiLimitBanner from "../../../components/ai-limit-banner";
import { calculateTime } from "../../../utils/TextManagerTwo";
import { Comment, Post as PostType } from "../../../types";
import ViewPost from "../../../components/Post/ViewPost";
import { useMessage } from '../../../global-components/src';
import ImgVerified from "../../../components/imgVerified/ImgVerified";
import NavbarMobile from "../../../components/navbar-mobile/navbar-mobile";
import NavbarPC from "../../../components/navbar-pc/navbar-pc";
import EditPost from "../../../components/Modals/EditPost";
import FormVerifyEmail from "../../../components/FormVerifyEmail/FormVerifyEmail";
import ModalPostLikes from "../PostLikes/ModalPostLikes";
// import ModalPostComments from "../PostLikes/ModalPostComments";
import RepostWithText from "../../../components/Modals/RepostWithText";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import { getImageUser } from "../../../global-components/src/utils/auth";
import ButtonBack from "../../../global-components/src/components/buttons/back";
import ModalCommentsBottom from "../../../components/Modals/comments/comments-bottom";
import PreviewSearch from "../../Settings/SearchScreen/preview-search";
import { getAppVersion, getNativeKeyboardHeight, getNativeNavigationHeight, isIOSWebView, isNewApp, isNewAppAndroid } from "../../../utils/platform";
import { Images, Laugh, X } from "lucide-react";
import ModalComments from "../../../components/Modals/comments/modal-comments";
import { censorText, clearText, verifyLinks } from "../../../global-components/src/utils/text";
import { renderTextWithPhoneMessageLinks } from '../../../utils/phone-message-links';
import EmojiPickerNative from "../../../components/Textarea/Emojis/emoji-picker-native";
import ReactPlayer from "react-player";
import { getImagePathBucketPacoca } from "../../../global-components/src/utils/utils";
import { useTranslation } from 'react-i18next';
import { compressImage, convertHeic } from "../../../global-components/src/utils/file";
import AnchoredDropdown, { DropdownItem } from "../../../components/AnchoredDropdown/AnchoredDropdown";

interface FilePreview {
    file: File;
    src: string;
    type?: string;
}

const PostCommentsResponses = () => {
    const { id: commentId } = useParams();
    const [comments, setComments] = useState<any[]>([]);
    const [originalComment, setOriginalComment] = useState<Comment>();
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPost, setIsLoadingPost] = useState(true);
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const { user } = useAuth();
    const minHeight = 20; // Altura mínima inicial
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const [text, setText] = useState("");
    const aiLimitBannerName = useAiMentionLimitBanner(text, user?.id);
    const [disabled, setDisabled] = useState(true);
    const [isEdditing, setIsEdditing] = useState(false);
    const [idCommentEdit, setIdCommentEdit] = useState(0);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [post, setPost] = useState<PostType | null>(null);
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const appVersion = getAppVersion();
    const [isFocusText, setIsFocusText] = useState(false);
    const [textareaHeight, setTextareaHeight] = useState(30);
    const [showEmoji, setShowEmoji] = useState(false);
    const fileInputRefComment = useRef<HTMLInputElement>(null);
    const [audioUrl, setAudioUrl] = useState<string | null>(null);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [selectedFiles, setSelectedFiles] = useState<FilePreview[]>([]);
    const placeholderText = originalComment?.id ? `Responder @${originalComment?.user.user_name}` : (isEdditing ? "Editar comentário" : "Adicionar comentário");

    const handleFile = async (file: any) => {
        file = await convertHeic(file);
        file = await compressImage(file);
        const type = file.type;
        const dataTransfer = new DataTransfer();

        if (type.startsWith("image/") && fileInputRefComment.current?.files) {
            dataTransfer.items.add(file);
            fileInputRefComment.current.files = dataTransfer.files;

            const reader = new FileReader();
            reader.onload = (e) => {
                const src = e.target?.result;
                if (typeof src === "string") {
                    setSelectedFiles(prev => [...prev, { file, src, type: "image" }]);
                }
            };
            reader.readAsDataURL(file);
        } else if (type.startsWith("video/") && fileInputRefComment.current) {
            const filtered = selectedFiles.filter(f => f.type !== "video");
            dataTransfer.items.add(file);
            fileInputRefComment.current.files = dataTransfer.files;
            const url = URL.createObjectURL(file);
            setSelectedFiles([...filtered, { file, src: url, type: "video" }]);
        }
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
        if (e.clipboardData.files && e.clipboardData.files.length > 0) {
            Array.from(e.clipboardData.files).forEach(file => handleFile(file));
        }
    };

    const handleMediaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files || !files.length) return;

        const selected = Array.from(files);

        setSelectedFiles(prev => {
            let imageCount = prev.filter(f => f.type === "image").length;
            let hasVideo = prev.some(f => f.type === "video");

            const result = [...prev];

            for (const file of selected) {
                if (file.type.startsWith("image/")) {
                    if (imageCount >= 5) continue;

                    result.push({
                        file,
                        src: URL.createObjectURL(file),
                        type: "image",
                    });

                    imageCount++;
                }

                if (file.type.startsWith("video/")) {
                    if (hasVideo) continue;

                    result.push({
                        file,
                        src: URL.createObjectURL(file),
                        type: "video",
                    });

                    hasVideo = true;
                }
            }

            return result;
        });

        // 👇 reset no próximo tick (CRUCIAL)
        setTimeout(() => {
            if (event.target) event.target.value = "";
        }, 0);
    };

    // placeholder
    const maxLength = 30;
    const originalText = originalComment?.text || '';
    const originalUser = originalComment?.user?.user_name || '';
    const previewText = originalText.length > maxLength ? `${originalText.slice(0, maxLength)}...` : originalText;
    const placeholder = `Responder @${originalUser}: ${previewText}`;
    const [bottomPadding, setBottomPadding] = useState(5);

    useEffect(() => {
        const root = document.getElementById("root");
        if (root) root.style.overflow = "hidden";

        return () => {
            if (root) root.style.overflow = "";
        };
    }, []);

    const loadPost = async () => {
        const url = PACOCA_API_URL + `/comments/find/${commentId}`;

        // if (loading) return;

        setIsLoadingPost(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.post) {
                setOriginalComment(data); // Pegando o primeiro item do array
                setPost(data.post); // Pegando o primeiro item do array
            }
        } catch (err: any) {
            console.error("Failed to load posts:", err);
            setHasMore(false)
            // if (err.response?.status === 401) setError(t("generics.errors.sessionExpired"));
            // if (err.response?.status === 429) setError(t("generics.errors.tooManyRequestsGeneric"));
        } finally {
            setIsLoadingPost(false);
        }
    };

    const updateText = (newText: string) => {
        setText(newText); // Atualiza o estado com o novo texto
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        const screenWidth = window.innerWidth; // Obtém a largura da tela

        if (e.key === "Enter") {
            e.preventDefault(); // Evita o comportamento padrão
            if (e.shiftKey || screenWidth <= 850) {
                setText((prevText) => prevText + "\n"); // Adiciona uma nova linha
            } else if (screenWidth > 850 && text.trim().length > 0) {
                handleSubmitComment(e as any); // Dispara o envio do formulário
            }
        }
    };

    const handleInputTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newText = event.target.value;
        setText(newText);
        setIsLimitExceeded(newText.length > LIMIT_TEXT_COMMENT);
    }

    const handleClickEmoji = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        setText((prev) => {
            if (prev[start - 1] === ":") return prev;

            const needsSpaceBefore =
                start > 0 && prev[start - 1] !== " " && prev[start - 1] !== "\n";

            const insertText = needsSpaceBefore ? " :" : ":";

            const newText =
                prev.substring(0, start) +
                insertText +
                prev.substring(end);

            setTimeout(() => {
                const pos = start + insertText.length;

                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = pos;

                // 🔥 SIMULA DIGITAÇÃO REAL
                textarea.dispatchEvent(new Event("input", { bubbles: true }));
            }, 0);

            return newText;
        });
    };

    // Função para ajustar a altura dinamicamente
    const adjustTextareaHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reseta a altura para calcular corretamente
            const newHeight = Math.max(minHeight, textareaRef.current.scrollHeight); // Garante a altura mínima
            textareaRef.current.style.height = `${newHeight}px`;
        }
    };

    const loadData = async () => {
        if (isLoading || !hasMore) return;

        setIsLoading(true);
        const url = `${PACOCA_API_URL}/comments/responses/${commentId}/?limit=${LIMIT_REQUEST_COMMENTS}&offset=${offset}`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            if (response.data.comments.length < LIMIT_REQUEST_COMMENTS) setHasMore(false);

            setComments((prevData) => [...prevData, ...response.data.comments]);
            setOffset((prevOffset) => prevOffset + LIMIT_REQUEST_COMMENTS);
        } catch (error) {
            console.error("Erro ao carregar comentários:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const body = document.body;
        if (body) body.style.overflow = "hidden";

        return () => {
            if (body) body.style.overflow = "auto";
        };
    }, []);

    const handleDelete = async (idComment: number) => {
        const url = `${PACOCA_API_URL}/comments/${idComment}`;

        try {
            setComments((prevData) => prevData.filter(comment => comment.id !== idComment));
            setOriginalComment((prevComment) => {
                if (!prevComment) return prevComment; // Evita erro caso o estado esteja indefinido
                return {
                    ...prevComment,
                    total_responses: Math.max(0, prevComment.total_responses - 1),
                };
            });

            await axios.delete(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

        } catch (err: any) {
            if (err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

            if (err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

            if (err.status == 401)
                setMessage(t("generics.errors.sessionExpired"), "error");

            if (err.response) {
                setMessage(err.response.data.message || "Erro ao comentar!", "error");
            } else if (err.request) {
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                setMessage("Ocorreu um erro inesperado!", "error");
            }
            console.error(err);
        }
    }

    const handleLike = async (idComment: number) => {
        const url = `${PACOCA_API_URL}/comments/like/${idComment}`;

        try {
            if (idComment == originalComment?.id) {
                setOriginalComment((prevComment) => {
                    if (!prevComment) return prevComment; // Evita erro caso o estado esteja indefinido

                    return {
                        ...prevComment,
                        is_liked: !prevComment.is_liked, // Alterna entre true/false
                        total_likes: prevComment.is_liked
                            ? Math.max(0, prevComment.total_likes - 1) // Evita valores negativos
                            : prevComment.total_likes + 1,
                    };
                });
            } else if (idComment == originalComment?.original_comment?.id) {
                setOriginalComment((prevComment) => {
                    if (!prevComment) return prevComment; // Evita erro caso o estado esteja indefinido

                    return {
                        ...prevComment,
                        original_comment: prevComment.original_comment
                            ? {
                                ...prevComment.original_comment,
                                is_liked: !prevComment.original_comment.is_liked, // Alterna entre true/false
                                total_likes: prevComment.original_comment.is_liked
                                    ? Math.max(0, prevComment.original_comment.total_likes - 1) // Evita valores negativos
                                    : prevComment.original_comment.total_likes + 1,
                            }
                            : prevComment.original_comment, // Retorna como está caso seja null/undefined
                    };
                });

            } else {
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === idComment ? {
                            ...comment, is_liked: !comment.is_liked,
                            total_likes: comment.is_liked
                                ? Math.max(0, comment.total_likes - 1) // Evita valores negativos
                                : comment.total_likes + 1,
                        } : comment
                    )
                );
            }

            await axios.post(url, {}, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

        } catch (err: any) {
            if (err.status == 401)
                setMessage(t("generics.errors.sessionExpired"), "error");

            if (err.response) {
                setMessage(err.response.data.message || "Erro ao comentar!", "error");
            } else if (err.request) {
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                setMessage("Ocorreu um erro inesperado!", "error");
            }

            if (err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

            if (err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");
            console.error(err);
        }
    }

    const clickEdit = (idComment: number, text: string) => {
        setIsEdditing(true)
        setText(text)
        setIdCommentEdit(idComment)
    }
    const cancelEdit = () => {
        setIsEdditing(false)
        setText("")
        setIdCommentEdit(0)
    }

    const handleSubmitComment = async (event: any, textLocal = text, isGif = false) => {
        if(event) event.preventDefault();
        setSelectedFiles([])

        if(textLocal && verifyLinks(textLocal)){
            setMessage("Link suspeito, você não pode realizar esse comentário", "error");
            setLoading(false);
            return;
        }

        setDisabled(true);
        const isEdit = idCommentEdit && idCommentEdit > 0;

        const oldText = textLocal;
        var tempId = Date.now(); // ID temporário
        const newCommentData = {
            total_likes: 0,
            total_responses: 0,
            id: tempId, // ID temporário
            gif_url: isGif ? textLocal : null,
            idNotSend: true,
            images: selectedFiles.map((media, index) => ({
                id: `temp-${tempId}-${index}`,
                path: media.src,
                type: media.type == "image" ? 0 : 1,
                isTemp: true
            })),
            user: {
                user_name: user?.user_name, // Imagem do usuário autenticado
                img_account: user?.img_account, // Imagem do usuário autenticado
                name: user?.name, // Nome do usuário
                verified_profile: user?.verified_profile, // Nome do usuário
                stamps: user?.stamps, // Nome do usuário
                position: user?.position, // Nome do usuário
            },
            textFormatted: textLocal, // Texto do comentário
            created_at: new Date().toISOString(), // Data do comentário
            can_edit: true, // Data do comentário
            can_delete: true, // Data do comentário
        };

        const formData = new FormData();
        formData.append("comment", textLocal);
        if (isGif)
            formData.append("gif_url", textLocal);
        formData.append("id_original_comment", String(originalComment?.id));

        selectedFiles.forEach(media => {
            if (media.type === "image") {
                formData.append("img[]", media.file);
            }

            if (media.type === "video") {
                formData.append("video", media.file);
            }
        });

        const audioFile = (document.getElementById("audio") as HTMLInputElement).files;
        if (audioFile && audioFile[0]) {
            formData.append("audio", audioFile[0]);
        }
        

        // Adiciona o comentário na lista antes de enviar a requisição
        if (!isEdit)
            setComments((prevComments) => [newCommentData, ...prevComments]);
        else {
            tempId = idCommentEdit
            setComments((prevComments) =>
                prevComments.map((comment) =>
                    comment.id === tempId ? { ...comment, id: idCommentEdit, textFormatted: text, idNotSend: true } : comment
                )
            );
        }
        cancelEdit()

        try {
            const url = !isEdit ? (`${PACOCA_API_URL}/comments/${post?.id}`) : (`${PACOCA_API_URL}/comments/${idCommentEdit}`);
            var response: any;

            if (!isEdit) {
                setOriginalComment((prevComment) => {
                    if (!prevComment) return prevComment; // Evita erro caso o estado esteja indefinido
                    return {
                        ...prevComment,
                        total_responses: prevComment.total_responses + 1,
                    };
                });

               
                // {
                //     comment: textLocal, id_original_comment: originalComment?.id, gif_url: isGif ? textLocal : null
                // }
                response = await axios.post(url, formData, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });
            } else {
                // {
                //     id_comment: idCommentEdit, comment: textLocal, id_original_comment: originalComment?.id
                // }
                formData.append("id_comment", String(idCommentEdit))
                response = await axios.patch(url, formData, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });
            }

            setComments((prevComments) =>
                prevComments.map((comment) =>
                    comment.id === tempId ? { ...comment, id: response?.data?.comment?.id, idNotSend: false } : comment
                )
            );
        } catch (err: any) {
            // Se houver erro, remove o comentário temporário
            setComments((prevComments) => prevComments.filter((comment) => comment.id !== tempId));
            setText(oldText);
            setDisabled(false);

            if (err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

            if (err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

            if (err.status == 401)
                setMessage(t("generics.errors.sessionExpired"), "error");

            if (err.response) {
                setMessage(err.response.data.message || "Erro ao comentar!", "error");
            } else if (err.request) {
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                setMessage("Ocorreu um erro inesperado!", "error");
            }
            console.error(err);
        }
    };

    useEffect(() => {
        setComments([]);
        setOffset(0);
        setHasMore(true);
        loadData();
        loadPost();
    }, [commentId]);

    useEffect(() => {
        const modalBody = document.getElementById("modal-comments-body");

        const handleScroll = () => {
            if (!modalBody) return;
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if (scrollTop + clientHeight >= scrollHeight - 50) {
                loadData();
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
            }
        };
    }, [loadData]);

    useEffect(() => {
        const handleKeyboardHeightChange = () => {
            const heightKeyboard = getNativeKeyboardHeight();
            const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;
            let height = 30;
            if (textareaRef.current) height = textareaRef?.current.clientHeight;

            setBottomPadding(heightKeyboard ? (heightKeyboard + nativeNavigationHeight + 10) : (nativeNavigationHeight + 10));
        };

        window.addEventListener("keyboardHeightChange", handleKeyboardHeightChange);

        return () => {
            window.removeEventListener("keyboardHeightChange", handleKeyboardHeightChange);
        };
    }, []);

    
    function ajustaNewApp() {
        if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
            const nativeNavigationHeight = getNativeNavigationHeight();
            let height = 30;
            if (textareaRef.current) height = textareaRef?.current.clientHeight;

            if(nativeNavigationHeight && nativeNavigationHeight > 0){
                setBottomPadding(nativeNavigationHeight + 10);
            }

            window.addEventListener("navigationBarHeightChange", ajustaNewApp);
            return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
        }
    }
    useEffect(() => {
        ajustaNewApp()
    }, []);

    useEffect(() => {
        if (selectedFiles.length > 0 || (text.length <= LIMIT_TEXT_COMMENT && text.trim().length > 0)) setDisabled(false)
        else setDisabled(true)
    }, [text, selectedFiles]);

    useEffect(() => {
        const handleModalClose = () => {
            setShow(false)
            setShowModalComments(false)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    const resizeTextarea = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const minHeight = 30; // mesma altura do rows={1}
        setTextareaHeight(minHeight);

        textarea.style.height = "auto";
        textarea.scrollTop = 0; // 🔑 limpa scroll antigo

        const scrollHeight = textarea.scrollHeight;

        const maxHeight = parseFloat(
            getComputedStyle(textarea).maxHeight || "0"
        );

        if (scrollHeight <= minHeight) {
            setTextareaHeight(minHeight);
            textarea.style.height = `${minHeight}px`;
            textarea.style.overflowY = "hidden";
            return;
        }

        if (maxHeight && scrollHeight > maxHeight) {
            setTextareaHeight(maxHeight);
            textarea.style.height = `${maxHeight}px`;
            textarea.style.overflowY = "auto";
        } else {
            setTextareaHeight(scrollHeight);
            textarea.style.height = `${scrollHeight}px`;
            textarea.style.overflowY = "hidden";
        }
    };

    useEffect(() => {
        resizeTextarea();
    }, [text]);

    
    const handleClickGif = (sticky: string) => {
        const oldText = text;
        handleSubmitComment(null, sticky, true);
        setText(oldText.slice(0, oldText.length - 1));
    }

    const handleRemoveMedia  = (index: number) => {
        setSelectedFiles(prev => {
            const file = prev[index];
            if (file?.src) URL.revokeObjectURL(file.src);

            return prev.filter((_, i) => i !== index);
        });
    };

    return (
        <Screen className="post-response-screen" paddingTopTitle title={post?.id ? `Respostas de ${originalComment?.user.name.split(" ")[0]}` : " "}
            footer={
                <>
                {/* !isLoading && post?.id */}
                    {true && (
                        <div className="modal-footer modal-footer-comment user-select-none" style={{ bottom: bottomPadding }}>
                            <div className="row row-comment" id="row-comment-{{$post?->id}}" style={{ width: "100%" }}>
                                <div className="col">
                                    {aiLimitBannerName ? <AiLimitBanner aiName={aiLimitBannerName} /> : null}
                                    <form className="form-comment" onSubmit={handleSubmitComment}>
                                        {user?.email_verified_at ? (
                                             <div className="d-flex" style={{ flexDirection: "column" }}>
                                                    {originalComment?.id ? (
                                                        <div className="response-user" style={{ bottom: bottomPadding + (selectedFiles.length ? 73 : 0) + textareaHeight + (window.innerWidth <=850 ? 27 : 27), background: "var(--background-post)" }}>
                                                            <p>Respondendo @{originalComment?.user.user_name}</p>
                                                        </div>
                                                    ) : null}
                                                    <div style={{ display: "flex", width: "100%" }}>
                                                       <div style={{ width: "100%" }}>
                                                            <div style={{ display: "flex", width: "100%" }}>
                                                            <textarea
                                                                rows={1}
                                                                value={text}
                                                                ref={textareaRef}
                                                                className="textarea-coamment-emoji form-control text-comment me-2"
                                                                placeholder={placeholderText}
                                                                // required
                                                                onChange={(e) => handleInputTextarea(e)}
                                                                    onKeyDown={(e) => handleKeyDown(e)}
                                                                    onPaste={handlePaste}
                                                                    style={{ background: "transparent!important" }}
                                                            />
                                                        </div>
                                                                                                
                                                        <EmojiPickerNative
                                                            show={showEmoji} 
                                                            setShow={setShowEmoji} 
                                                            onSelect={(emoji) => { 
                                                                setText(prev => prev + emoji); 
                                                                // textareaRef.current?.focus() 
                                                            }} 
                                                            handleClickGif={handleClickGif}
                                                            bottom={bottomPadding + textareaHeight + (selectedFiles.length ? 73 : 0) + (window.innerWidth <= 850 ? 35 : 30)}
                                                        />
                                                        <PreviewSearch 
                                                            textareaRef={textareaRef} 
                                                            text={text} 
                                                            setText={setText}
                                                            bottom={bottomPadding + textareaHeight + (selectedFiles.length ? 73 : 0) + (window.innerWidth <= 850 ? 35 : 30)}
                                                        />

                                                        <div className={`row row-preview-img ${selectedFiles.length > 1 ? "row-preview-img-multiple" : ""}`}>
                                                            {selectedFiles.map((file, index) => (
                                                                <>
                                                                    {file.type === "image" ? (
                                                                        <div key={index} className="row-label-img-comment">
                                                                            <div className="btn-container-add-img" style={{ marginBottom: "5px", display: "flex", gap: "5px", position: "relative" }}>
                                                                                <button type="button" onClick={() => handleRemoveMedia(index)} className="btn-x-right btn-close svg-icons-color btn-dark" style={{ right: 0, top: 7 }}>
                                                                                    <X/>
                                                                                </button>
                                                                            </div>
                                                                            <img alt={`preview-${index}`} src={file.src} className="label-img img-preview-comment"/>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <div className="row row-label-video" style={{ margin: 0, height: "100%", minHeight: selectedFiles.length > 1 ? 300 : 250, overflow: "auto", position: "relative" }}>
                                                                                <button type="button" onClick={() => handleRemoveMedia(index)} className="btn-x-right btn-close svg-icons-color btn-dark">
                                                                                    <X/>
                                                                                </button>
            
                                                                                <label className="label-img label-video" style={{ minHeight: selectedFiles.length > 1 ? 300 : 0 }} htmlFor="video">
                                                                                    <ReactPlayer url={file.src} style={{ objectFit: "cover", minHeight: selectedFiles.length > 1 ? 300 : 250, maxHeight: selectedFiles.length > 1 ? 300 : 250 }} controls width="100%" className="video-preview" />
                                                                                </label>
                                                                            </div>    
                                                                        </>
                                                                    )}
                                                                </>
                                                            ))}
                                                        </div>

                                                        <div style={{ display: "flex", gap: 10 }}>
                                                            <div className="cursor-pointer div-emoji-chat" onClick={() => { fileInputRefComment.current?.click() }}>
                                                                <Images className="icon-comment-sticky"/>
                                                            </div>
                                                            <div className="cursor-pointer div-emoji-chat" onClick={() => setShowEmoji(true)}>
                                                                <Laugh className="icon-comment-sticky"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input type="file" ref={fileInputRefComment} multiple accept="image/*,video/*" onChange={handleMediaChange} style={{ position: "fixed", top: -10000, zIndex: 0 }} name='imgComment' id='imgComment' />


                                                    <button className="btn btn-blue-send-comment button-submit-comment" disabled={disabled || !post?.id}>
                                                        <Send className="icon-send-comment" data-feather="send" />
                                                    </button>

                                                    {isEdditing ? (
                                                        <button onClick={cancelEdit} className="btn btn-red-cancel-comment button-cancel-edit-comment" type="button" >
                                                            <XSquare className="icon-send-comment" data-feather="x-square" />
                                                        </button>
                                                    ) : null}
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <p style={{ marginBottom: 10 }}>Verifique o email para comentar</p>
                                            <FormVerifyEmail />
                                        </>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </>
        } >
            <NavbarPC />
            <div className="row row-screen-comments" style={{ justifyContent: "center" }}>
                {/* POST */}
                {post ? (
                    <ViewPost setPost={setPost} onOpenComments={() => setShowModalComments(true)} onOpenLikes={() => {setShow(true);}} key={commentId} post={post} />
                ) : null}

                <EditPost
                    onEdit={(newText, gifUrl) => {
                        // Atualizar o estado global da lista de posts
                        setPost((preData) =>
                            preData ? { ...preData, text: newText, gif_url: gifUrl ?? null } : null
                        );

                    }}
                    post={post}
                />

                {/* COMENTARIO */}
                {originalComment?.original_comment ? (
                    <div id="original-coment" className="row card-comment-open-dark original-coment-dark" style={{ marginTop: "5px", zIndex: 1 }}>
                        <img className="user-select-none col-1 img-account-likes img-account-comment" src={getImageUser(originalComment?.original_comment?.user?.img_account)} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                        <div className="col col-comment-text">
                            <div className="comment-text">
                                <div className="col-12 d-flex" style={{ gap: "5px", alignItems: "center", flexWrap: "wrap" }}>
                                    <Link className="name-comment user-name-view-comment" to={`/@${originalComment?.original_comment?.user?.user_name}`}>
                                        <h1 style={{ fontSize: "17px", marginBottom: 0 }}>
                                            <span>
                                                {originalComment?.original_comment?.user?.name}
                                                <ImgVerified user={originalComment?.original_comment?.user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                                                {originalComment?.original_comment?.user?.id == post?.user.id && <span className="author-comment" style={{ marginLeft: originalComment?.original_comment?.user.position || originalComment?.original_comment?.user?.stamps ? "0px" : "0" }}>autor</span>}
                                            </span>
                                        </h1>
                                    </Link>
                                    <div>
                                        <p className="date-comment date-comment-view-comment" style={{ marginBottom: 0 }}></p>
                                        {/* <p className="username-comment username-view-comment w-100">@{originalComment?.original_comment?.user?.user_name}</p> */}
                                    </div>
                                </div>

                                {!originalComment?.original_comment.gif_url && (
                                    <p dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(originalComment?.original_comment?.text || ""), clearText) }} className="text-comment text-comment-view-comment cursor-pointer"/>
                                )}

                                {originalComment?.original_comment?.images && originalComment?.original_comment.images.length > 0 && (
                                    <div className="comment-media">
                                        {originalComment?.original_comment.images.map((media, index) => (
                                            <div key={media.id ?? index} className="comment-media-item">
                                                {media.type == 0 ? (
                                                    <img
                                                        onError={(e) => (e.currentTarget.src = "/img/image_not_found.png?v=1")}
                                                        src={media.isTemp ?  media.path : getImagePathBucketPacoca(media.path)}
                                                        alt={`comment-media-${index}`}
                                                        className="comment-image"
                                                    />
                                                ) : (
                                                    <video
                                                        src={getImagePathBucketPacoca(media.path)}
                                                        controls
                                                        className="comment-video"
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {originalComment?.original_comment.gif_url && (
                                    <img
                                        src={originalComment?.original_comment.gif_url}
                                        className="comment-gif"
                                        alt="GIF"
                                    />
                                )}

                            </div>
                            <div className="icons-config-comment user-select-none">
                                <div className="response-icon-comment">
                                    {originalComment?.original_comment?.total_responses} <MessageCircle className="icon-comment-response" data-feather="message-circle" />
                                </div>
                                <div className="response-icon-comment cursor-pointer" onClick={() => handleLike(originalComment?.original_comment?.id ?? 0)}>
                                    {originalComment?.original_comment?.total_likes} <Heart className={`${originalComment?.original_comment?.is_liked ? 'icon-heart-comment-liked' : ''} icon-heart-comment icon-comment-response`} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                {originalComment?.original_comment ? (
                    <div style={{ position: "relative" }}>
                        <div className="line-follow-comment-vertical"></div>
                        <div className="line-follow-comment-horizontal"></div>
                    </div>

                ) : null}

                {/* COMENTARIO */}
                {originalComment ? (
                    <div id="original-coment" className="row card-comment-open card-comment-open-page original-coment" style={{ marginTop: "5px", marginLeft: 0 }}>
                        <img className="user-select-none col-1 img-account-likes img-account-comment" src={getImageUser(originalComment?.user?.img_account)} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                        {/* <div className="col-1 img-account-likes img-account-comment img-account-search img-account-view-search" style={{ backgroundImage: `url("${getImageUser(originalComment?.user?.img_account)}")` }}></div> */}
                        <div className="col col-comment-text">
                            <div className="comment-text">
                                <div className="col-12 d-flex" style={{ gap: "5px", alignItems: "center", flexWrap: "wrap" }}>
                                    <Link className="name-comment user-name-view-comment" to={`/@${originalComment?.user.user_name}`}>
                                        <h1 style={{ fontSize: "12.5px", marginBottom: 0 }}>
                                            <span>
                                                {originalComment?.user.name}
                                                <ImgVerified user={originalComment?.user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                                            </span>
                                            {originalComment?.user?.id == post?.user?.id && <span className="author-comment" style={{ marginLeft: originalComment?.user.position || originalComment?.user?.stamps ? "0px" : "0" }}>autor</span>}
                                        </h1>
                                    </Link>
                                    <div>
                                        <p className="date-comment date-comment-view-comment" style={{ marginBottom: 0 }}></p>
                                        {/* <p className="username-comment username-view-comment w-100">@{originalComment?.user.user_name}</p> */}
                                    </div>
                                </div>
                                {!originalComment?.gif_url && (
                                    <p dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(originalComment.text || ""), clearText) }} className="text-comment text-comment-view-comment cursor-pointer"/>
                                )}

                                {originalComment?.gif_url && (
                                    <img
                                        src={originalComment?.gif_url}
                                        className="comment-gif"
                                        alt="GIF"
                                    />
                                )}

                                {originalComment?.images && originalComment.images.length > 0 && (
                                    <div className="comment-media">
                                        {originalComment.images.map((media, index) => (
                                            <div key={media.id ?? index} className="comment-media-item">
                                                {media.type == 0 ? (
                                                    <img
                                                        onError={(e) => (e.currentTarget.src = "/img/image_not_found.png?v=1")}
                                                        src={media.isTemp ?  media.path : getImagePathBucketPacoca(media.path)}
                                                        alt={`comment-media-${index}`}
                                                        className="comment-image"
                                                    />
                                                ) : (
                                                    <video
                                                        src={getImagePathBucketPacoca(media.path)}
                                                        controls
                                                        className="comment-video"
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="icons-config-comment user-select-none">
                                <div className="response-icon-comment">
                                    {originalComment?.total_responses} <MessageCircle className="icon-comment-response" data-feather="message-circle" />
                                </div>
                                <div className="response-icon-comment cursor-pointer" onClick={() => handleLike(originalComment?.id ?? 0)}>
                                    {originalComment?.total_likes} <Heart className={`${originalComment?.is_liked ? 'icon-heart-comment-liked' : ''} icon-heart-comment icon-comment-response`} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            

                <Helmet>
                    <title>Paçoca - Respostas</title>
                    <meta name="description" content="Paçoca, sua nova rede social." />
                </Helmet>

                {/* LISTAGEM DE COMENTARIOS */}
                <div style={{ minHeight: "calc(100dvh - 50px)" }}>
                    {isLoading || isLoadingPost ? (
                        <div className="row user-select-none row-empty">
                            <LoadingThreeCircle style={{justifyContent: "center"}}/>
                            {/* <Spinner className="text-primary" size="20" borderWidth="2" /> */}
                        </div>
                    ) : (
                        <>
                        



                            <div style={{ minHeight: "calc(100dvh - 50px)", marginLeft: 40, position: "relative" }}>
                            {/* {comments.map((comment) => (
                                
                            ))} */}
                                {comments.map((comment: Comment, index) => (
                                    <div key={comment.id} className="row card-comment" id="start-here" style={{ marginTop: "5px", marginRight: "-10px", marginLeft: "0px", margin: "0!important", position: "relative" }}>
                                        <div style={{position: "absolute"}}>
                                            <div id={index == 0 ? `line-follow-comment-vertical2-first` : "line-follow-comment-vertical2"}></div>
                                            <div id="line-follow-comment-horizontal2"></div>
                                        </div>

                                        <img src={comment.user.img_account ? (BUCKET_PACOCA_URL + "/" + comment.user.img_account) : "/img/img-account.png"} className="user-select-none col-1 img-account-comment" onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                                        <div className="col col-comment-text">
                                            <div className="comment-text">
                                                {/* EDICAO E EXCLUSAO */}
                                                {comment.can_edit || comment.can_delete ? (
                                                    <div className="col-1 col-conf-post" style={{ position: "absolute", zIndex: 1 }}>
                                                        <AnchoredDropdown>
                                                            {comment.can_edit ? (
                                                                <DropdownItem icon={<Edit size={15} className="icon-config-post" />} onClick={() => clickEdit(comment.id, comment.textFormatted)}>
                                                                    Editar
                                                                </DropdownItem>
                                                            ) : null}
                                                            {comment.can_delete ? (
                                                                <DropdownItem icon={<Trash size={15} className="icon-config-post" />} danger onClick={() => handleDelete(comment.id)}>
                                                                    Excluir
                                                                </DropdownItem>
                                                            ) : null}
                                                        </AnchoredDropdown>
                                                    </div>
                                                ) : null}
                                                
                                                <div className="col-12 d-flex open-comment" style={{ gap: "5px", alignItems: "center", flexWrap: "wrap", }}>
                                                    <Link className="name-comment" to={`/@${comment.user.user_name}`}>
                                                        <h1 style={{ fontSize: "12.5px", marginBottom: 0 }}>
                                                            <span>
                                                                {comment?.user?.name || ''}
                                                                <ImgVerified user={comment.user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                                                            </span>
                                                            {comment?.user?.id == post?.user?.id && <span className="author-comment" style={{ marginLeft: comment?.user.position || comment?.user?.stamps ? "0px" : "0" }}>autor</span>}
                                                        </h1>
                                                    </Link>

                                                    <div style={{ marginTop: -8 }}>
                                                        <p className="date-comment">{calculateTime(comment.created_at)}</p>
                                                    </div>
                                                </div>
                                                {!comment.gif_url && (
                                                    <p className="text-comment open-comment" dangerouslySetInnerHTML={{ __html: renderTextWithPhoneMessageLinks(censorText(comment.textFormatted || ""), clearText) }}/>
                                                )}
                                                
                                                {comment.gif_url && (
                                                    <img
                                                        src={comment.textFormatted}
                                                        className="comment-gif"
                                                        alt="GIF"
                                                    />
                                                )}

                                                {comment?.images && comment.images.length > 0 && (
                                                    <div className="comment-media">
                                                        {comment.images.map((media, index) => (
                                                            <div key={media.id ?? index} className="comment-media-item">
                                                                {media.type == 0 ? (
                                                                    <img
                                                                        onError={(e) => (e.currentTarget.src = "/img/image_not_found.png?v=1")}
                                                                        src={media.isTemp ?  media.path : getImagePathBucketPacoca(media.path)}
                                                                        alt={`comment-media-${index}`}
                                                                        className="comment-image"
                                                                    />
                                                                ) : (
                                                                    <video
                                                                        src={getImagePathBucketPacoca(media.path)}
                                                                        controls
                                                                        className="comment-video"
                                                                    />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                            </div>
                                                <div className="icons-config-comment user-select-none">
                                                    <div className="response-icon-comment">
                                                        {comment.total_responses} <MessageCircle className="icon-comment-response" data-feather="message-circle" />
                                                    </div>
                                                    <div className="response-icon-comment cursor-pointer" onClick={() => handleLike(comment.id)}>
                                                        {comment.total_likes} <Heart className={`${comment.is_liked ? 'icon-heart-comment-liked' : ''} icon-heart-comment icon-comment-response`} />
                                                    </div>
                                                    <div onClick={() => navigate(`/post/comentarios/respostas/${comment.id}`)} className="response-icon-comment cursor-pointer mt-1 d-flex" style={{ fontSize: "12px", alignItems: "center" }}>
                                                        Respostas
                                                    </div>
                                                </div>
                                                {comment.idNotSend ? (
                                                    <div className="d-flex w-100 div-status-comment" style={{ justifyContent: "right" }}>
                                                        <Clock className={`comment-father-icon ${comment.idNotSend == "error" ? "comment-father-red" : ""}`} />
                                                    </div>
                                                ) : null}
                                        </div>
                                    </div>
                                ))}

                                {post?.id && comments.length === 0 && (
                                    <div className="user-select-none row row-empty-comment" style={{marginLeft: "-40px" }}>
                                        <span className="span-empty">
                                            <MessageCircle className="icon-empty" />
                                            <h3 className="w-100 text-center">Seja o primeiro a responder</h3>
                                        </span>
                                    </div>
                                )}

                                {!post?.id && (
                                    <div className="user-select-none row row-empty-comment" style={{marginLeft: "-40px"}}>
                                        <span className="span-empty">
                                            <Trash className="icon-empty" />
                                            <h3 className="w-100 text-center">Esse comentário foi excluido</h3>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
</div>
                <RepostWithText id_post={Number(post?.id)} />
                <ModalPostLikes idPostSelected={Number(post?.id)} show={show} />
                {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={Number(post?.id)}/> : <ModalComments idPostSelected={Number(post?.id)} show={showModalComments} />}

                <div id="is-navbar-static"></div> {/* permite que navbarbottom fica static */}
        </Screen>
    );
};

export default PostCommentsResponses;
